<template>
	<div class="privacy_container">
		<!-- 导航栏 -->
		<!-- <van-nav-bar
			:title="title"
			left-arrow
			@click-left="onClickLeft"
			safe-area-inset-top
		>
			<template #left>
				<van-icon name="arrow-left" size="18" color="#333333" style="fontWeight: 600" />
			</template>
		</van-nav-bar> -->

		<!-- 协议详情 -->
		<div class="privacy_background" v-html="content"></div>
	</div>
</template>

<script>

export default {
	name: 'PrivacyAgreement',
	data () {
		return {
			agreementUrl: '',
			// title: '',
			content: '',
			isFirst: true
		}
	},
	created () {
		this.type = this.$route.params.type
		// switch (this.type) {
		// 	case 'user':
		// 		this.title= '用户服务协议'
		// 		break;

		// 	case 'hide':
		// 		this.title= '隐私协议'
		// 		break;

		// 	case 'shop_refund':
		// 		this.title= '商城退款协议'
		// 		break;

		// 	case 'score':
		// 		this.title= '积分规则'
		// 		break;

		// 	default:
		// 		break;
		// }
	},
	async mounted() {
		await this.getAgreementDetail()
	},
	methods: {
		async getAgreementDetail () {
			try{
				let res = await this.$http({
					url: '/user/get-rule',
					method: 'post',
					data: { type: this.type }
				})
				if (!!res.data && res.data.code === 200) {
					this.content = res.data.data.content
				}
			}catch(e){}
		},

		// onClickLeft() {
		// 	let isAndroid = this.$PLATFORM.isAndroid
		// 	let isiOS = this.$PLATFORM.isiOS

		// 	if (isAndroid) {
		// 		this.$toast('isAndroid')
		// 	} else if (isiOS) {
		// 		this.$toast('isiOS')
		// 	} else {
		// 		this.$toast('非移动端')
		// 	}
		// }
	}
}

</script>

<style scoped>
	/* .privacy_container {
		height: 100vh;
		overflow-y: scroll;
		user-select:none;
	} */

	/* .privacy_container >>> .van-nav-bar__title {
		font-size: 17px;
		font-weight: 600;
	} */


.privacy_background {
  user-select: none;
  min-height: 100vh;
  padding: 10px 20px 40px;
  box-sizing: border-box;
  width: 100vw;
  word-break: break-all;
  line-height: 22px;
  overflow-x: hidden;
}
</style>
